    // 环信客服按钮逻辑
    var img_class_box = document.getElementById('img_class_box')
    var huanxin_customer_service = document.getElementById('huanxin_customer_service')

    // 点击唤起
    huanxin_customer_service.addEventListener('click',(e)=>{
      click_huanxin()
    })
    huanxin_customer_service.onmouseover = function() {
      mouseleave_fun()
    }

    huanxin_customer_service.onmouseout = function() {
      onmouseout_fun()
    }

    function mouseleave_fun(){
      let img_class = document.getElementById('img_class')
      let img = document.getElementById('img_src')
      img.style.transition = '0.4s'
      img.style.transform = 'scale(5)'
    }
    function onmouseout_fun(){
      let img_class = document.getElementById('img_class')
      let img = document.getElementById('img_src')
      img.style.transition = '0.4s'
      img.style.transform = 'scale(0)'
    }

    let class_Passenger = true
    function click_huanxin(){
      mouseleave_fun()
      setTimeout(() => {onmouseout_fun()}, 600)

      console.log(class_Passenger)
      window.easemobim = window.easemobim || {};
      easemobim.config = {
        hide: true,
        autoConnect: false,
        configId: '5c8b614f-8d90-4060-88f1-673d508301d5',
        //打开
        onopen: function () {
          console.log('打开')
          class_Passenger = false
          img_class_box.style.display = 'none'
        },
        //收起
        onclose: function () {
          class_Passenger = true
          img_class_box.style.display = 'block'
          console.log('收起')
        },
      }
      easemobim.bind({configId: "5c8b614f-8d90-4060-88f1-673d508301d5"})  
    }